import NotFoundPage from './NotFoundPage';
import Test from './Test';
import Login from './LoginPage';
import Dashboard from './Dashboard';
import Employees from './Employees';
import Departments from './Departments';
import AssignPassword from './AssignPassword';
import Enterprise from './Enterprise';
import DefinitionCourses from './DefinitionCourses';
import DefinitionCoursesEnterprise from './DefinitionCoursesEnterprise';
import DefinitionCoursesDepartment from './DefinitionCoursesDepartment';
import DefinitionCoursesJobTitle from './DefinitionCoursesJobTitle';
import DefinitionSelectDepartment from './DefinitionSelectDepartment';
import DefinitionSelectJobTitle from './DefinitionSelectJobTitle';
import JobTitles from './JobTitles';
import EmployeeAssess from './EmployeeAssess';
import DevelopmentPlan from './DevelopmentPlan';
import MyCourses from './MyCourses';
import Courses from './courses';
import EditCourse from './EditCourse';
import CourseDetails from './CourseDetails';
import Lessons from './Lessons';
import Evaluations from './Evaluations';
import Achievements from './Achievements';
import TestInformation from './TestInformation';
import TestStart from './TestStart/test-start';
import Attendance from './Attendance';
import Reports from './reports/reports';
import CoursesReports from './reports/[submodules]/courses/courses';
import EmployeesReports from './reports/[submodules]/employees/employees';
import EmployeesReportsById from './reports/[submodules]/employees/$employeeId';
import CoursesReportsById from './reports/[submodules]/courses/$courseId';
import HistoryReports from './reports/[submodules]/history/history-employees';
import HistoryReportsById from './reports/[submodules]/history/history-$employeeId';
import CoursesLessons from './courses/[submodules]/lessons/courses-lessons';
import Roles from './Roles';
import RoleCreate from './RoleCreate/role-create';
import HistoryCoursesReports from './reports/[submodules]/history/history-courses';
import HistoryCoursesReportsById from './reports/[submodules]/history/history-$courses';
import SessionsReports from './reports/[submodules]/sessions/sessions';
import SessionEmployeesReports from './reports/[submodules]/sessions/sessions-employees';
import JobTitleCoursesReport from './reports/[submodules]/job-titles/job-title-courses';
import SessionReportDetail from './SessionReportDetail';
import Settings from './Settings';
import SettingsInstructors from './Settings/Instructors';
import SettingsNews from './Settings/News';

export default {
  NotFoundPage,
  Test,
  Login,
  Dashboard,
  Employees,
  Departments,
  AssignPassword,
  Enterprise,
  DefinitionCourses,
  DefinitionCoursesEnterprise,
  DefinitionCoursesDepartment,
  DefinitionCoursesJobTitle,
  DefinitionSelectDepartment,
  DefinitionSelectJobTitle,
  JobTitles,
  EmployeeAssess,
  DevelopmentPlan,
  MyCourses,
  Courses,
  EditCourse,
  CourseDetails,
  Lessons,
  Evaluations,
  Achievements,
  TestInformation,
  TestStart,
  Attendance,
  Reports,
  CoursesReports,
  EmployeesReports,
  EmployeesReportsById,
  CoursesReportsById,
  HistoryReports,
  HistoryReportsById,
  HistoryCoursesReports,
  HistoryCoursesReportsById,
  SessionsReports,
  SessionEmployeesReports,
  JobTitleCoursesReport,
  SessionReportDetail,
  CoursesLessons,
  Roles,
  RoleCreate,
  Settings,
  SettingsInstructors,
  SettingsNews,
};
